import service from '@/services/SICUDdoc_eval_val';

export default {
  namespaced: true,

  actions: {
    /** Petición para actualizar el valor de una etiqueta en una evaluación */
    update({ dispatch, rootGetters }, value) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDdoc_eval_val: {
            eeDatos: [rootGetters['auth/state']],
            eedoc_eval_val: [value],
          },
        };

        let notification;

        service
          .update(payload)
          .then((response) => {
            const data = response.data.dsSICUDdoc_eval_val;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data?.eedoc_eval_val);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: error.name || undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
